'use client';
import { Line, Vector } from '../../../../public/Images/old-images';
import Typography from '@/components/shared/typography/typography.component';
import SelectMakeCard from './make-card/make-card.component';
import { useTranslation } from '@/hook';
import styles from './styles.module.scss';
import Image from 'next/image';

const Banner = () => {
    const { t, IS_RTL } = useTranslation();

    return (
        <div className={styles.banner_container}>
            <Image
                src={Vector.src}
                width={Vector.width}
                height={Vector.height}
                style={{
                    position: 'absolute',
                    left: 0,
                    width: '100%',
                    top: '-4.5%',
                    zIndex: 1,
                }}
                alt="ribbon"
            />
            <div className={styles.text_container}>
                <Typography
                    style={{ paddingTop: '14vh' }}
                    className={styles.banner_header}
                >
                    {t('bannerHeader1')}
                </Typography>{' '}
                <Typography className={styles.banner_header}>
                    {t('bannerHeader2')}
                </Typography>
                <Image
                    src={Line.src}
                    width={Line.width}
                    height={Line.height}
                    style={{ width: IS_RTL ? '52vw' : '' }}
                    alt="line"
                />
            </div>
            <div className={styles.card_container}>
                <SelectMakeCard />
            </div>
        </div>
    );
};

export default Banner;
